import React, {PureComponent} from "react";
import Input from "./Input";
import SelectInput from "./SelectInput";
import Select from "react-select";
import ErrorSpan from "../ErrorSpan";

const yesNoValues = { 1: 'Так',  0: 'Ні' };

export default class ConsumptionBlock extends PureComponent {
    constructor() {
        super(...arguments);

        this.operator_grms = this.props.operator_grms;
        this.building_types = this.props.building_types;
        this.gas_devices = this.props.gas_devices_op;

        this.handleChangeEic = this.handleChangeEic.bind(this);
        this.handleBlurEic = this.handleBlurEic.bind(this);
        this.handleChangeInt = this.handleChangeInt.bind(this);
        this.handleChangeFloat = this.handleChangeFloat.bind(this);
    }

    handleChangeEic(attr, value) {
        if (!value.match(/^56X[a-zA-Z0-9]{0,13}$/)) {
            this.props.updateErrors(attr, 'Невірний формат EIC-кода')
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value.toUpperCase());
        }
    }

    handleBlurEic(attr, value) {
        if (!value.match(/^56X[a-zA-Z][0-4,9][0-9][a-zA-Z][0-9]{8}[a-zA-Z0-9]$/) || value.length === 0) {
            this.props.updateErrors(attr, 'Невірний формат EIC-кода');
        } else {
            this.props.updateErrors(attr, null);
        }
    }

    handleChangeInt(attr, value) {
        if(!value.match(/^[0-9]*$/)) {
            this.props.updateErrors(attr, 'Поле має містити цілі числа');
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value);
        }
    }

    handleChangeFloat(attr, value) {
        if(!value.match(/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/)) {
            this.props.updateErrors(attr, 'Поле має містити число з двома знаки після крапки');
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value);
        }
    }

    render() {
        const {
            eic,
            operator_grm_id,
            building_type,
            gas_devices,
            registered_persons,
            building_square,
            has_counter,
            errors
        } = this.props;

        return (
            <div>
                <hr/>
                <h4 className="my-4 font-weight-bolder">Об'єкт газопостачання</h4>
                <div className="row">
                    <div className="col-sm-6">
                        <Input attr={'eic'} value={eic} label='EIC-код'
                               onChange={this.handleChangeEic}
                               onBlur={this.handleBlurEic}
                               error={errors.eic} required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label='Оператор ГРМ'
                            attribute={'operator_grm_id'}
                            value={operator_grm_id}
                            options={this.operator_grms}
                            optionsSortCallback={function (el) {if(el.label === 'Одесагаз') return -1}}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.operator_grm_id}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label="Вид об'єкта"
                            attribute={'building_type'}
                            value={building_type}
                            options={this.building_types}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.building_type}
                        />
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="">
                                Газові прилади <span className="text-danger">*</span>
                            </label>
                            <Select
                                className='react-select-container'
                                classNamePrefix="react-select"
                                isMulti
                                value={gas_devices}
                                placeholder={"Оберіть"}
                                onChange={(value) => this.props.onChange('gas_devices', value) }
                                options={_.map(this.gas_devices, (name, id) => {
                                    return {value: id, label: name};
                                })}
                            />
                            {errors.gas_devices && <ErrorSpan error={errors.gas_devices}/>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <SelectInput
                                label={'Наявність лічильника'}
                                attribute={'has_counter'}
                                value={has_counter}
                                options={yesNoValues}
                                onChange={this.props.onChange}
                                error={errors.has_counter}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <Input
                            attr={'registered_persons'}
                            value={registered_persons}
                            label='Кількість зареєстрованих осіб'
                            placeholder='Введіть к-ть зареєстрованих осіб'
                            onChange={this.handleChangeInt}
                            error={errors.registered_persons}
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            attr={'building_square'}
                            value={building_square}
                            label="Площа об'єкта"
                            placeholder="Введіть площу об'єкта"
                            onChange={this.handleChangeFloat}
                            error={errors.building_square}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
